import { render } from "./Appendix.vue?vue&type=template&id=61e34a14"
import script from "./Appendix.vue?vue&type=script&lang=js"
export * from "./Appendix.vue?vue&type=script&lang=js"

import "./Appendix.vue?vue&type=style&index=0&id=61e34a14&lang=less"
script.render = render

export default script